import { render, staticRenderFns } from "./ServiceChat.vue?vue&type=template&id=6de36f24&scoped=true"
import script from "./ServiceChat.vue?vue&type=script&lang=js"
export * from "./ServiceChat.vue?vue&type=script&lang=js"
import style0 from "./ServiceChat.vue?vue&type=style&index=0&id=6de36f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de36f24",
  null
  
)

export default component.exports